import { Grid, withStyles } from '@material-ui/core';
import React from 'react';
import { Paper } from '../common/Paper';
import { Typography } from '../common/Typography';
import { Content, ContentDisplayName } from '../services/UploadManagementServiceTypes';
import { ContentActions, ContentActionsProps } from './ContentActions';
import { ContentDate } from './ContentDate';
import { ContentIcon } from './ContentIcon';
import { useDragAndDropEvents } from './useDragAndDropEvents';

export const ContentGrid: React.FC = ({ children }) => (
  <Grid container spacing={3}>
    {children}
  </Grid>
);

export interface ContentGridItemProps extends Omit<ContentActionsProps, 'menuLabel'> {
  content: Content;
  openContent: () => void;
  contentDisplayName: ContentDisplayName;
  thumbnail?: string;
}

const IconGrid = withStyles({
  root: { height: '195px', cursor: 'pointer' },
})(Grid);

const ContainerGrid = withStyles({
  root: {
    paddingBottom: '10px',
    width: '195px',
    '&:hover': {
      backgroundColor: '#E8E8E8',
    },
  },
})(Grid);

const LeftPaddedGrid = withStyles({
  root: { padding: '0 0 0 7px' },
})(Grid);

export const ContentGridItem: React.FC<ContentGridItemProps> = ({
  content,
  openContent,
  contentDisplayName,
  thumbnail,
  ...actionConfigs
}) => {
  const dragAndDropProps = useDragAndDropEvents(content);

  return (
    <Grid item {...dragAndDropProps} role='gridcell'>
      <Paper>
        <ContainerGrid container direction='column' role='grid'>
          <IconGrid
            container
            style={{ background: thumbnail ? `center no-repeat url(${thumbnail})` : 'none' }}
            alignItems='center'
            direction='column'
            justify='center'
            onClick={openContent}
          >
            <ContentIcon displayName={contentDisplayName} iconSize={96} draggable={false} />
          </IconGrid>
          <LeftPaddedGrid container alignItems='center' justify='space-between' wrap='nowrap'>
            <Grid style={{ overflow: 'hidden' }}>
              <Typography noWrap>{content.name}</Typography>
            </Grid>
            <Grid>
              <ContentActions {...actionConfigs} iconVertical />
            </Grid>
          </LeftPaddedGrid>
          <LeftPaddedGrid item>
            <ContentDate content={content} />
          </LeftPaddedGrid>
        </ContainerGrid>
      </Paper>
    </Grid>
  );
};
